module.exports = __webpack_public_path__ + "static/media/georgia.6b0596c7.jpg";